import { faArrowRight, faSearch, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useRef, useState } from 'react'
import { useDebounce, useDebounce1 } from '../../../hooks/useDebounce';
import { useDispatch, useSelector } from 'react-redux';
import { searchCoursePersonalise } from '../../../redux/actions/personalize';
import './Personalise.css'

const SearchBar = ({token , type , count , dropdownResult , setDropdownResult , utmSource}) => {
  const inputRef = useRef(null);
  const dispatch = useDispatch();
  const [searchText, setSearchText] = useState("");

  const [isOpenModal , setIsOpenModal] = useState(false);

  // const handleInputChange = useDebounce1((e) => {
  //   if (e.target.value === "") {
  //     setDropdownResult(null);
  //     setSearchText(e.target.value);
  //     return;
  //   }
  //   // console.log(e.target.value)
  //   setSearchText(e.target.value);
  //   dispatch(searchCoursePersonalise(searchText,token, (successObj)=>{ setDropdownResult(successObj)} , (erroObj)=> {})
  //   );
  // }, 500);

  const debouncedSearchValue = useDebounce(searchText, 500)

  console.log('drop' , dropdownResult)
  useEffect(()=>{
    if (debouncedSearchValue?.length > 0){
    
      dispatch(searchCoursePersonalise(searchText,token, (successObj)=>{ setDropdownResult(successObj)} , (erroObj)=> {}));

    }
    else if(debouncedSearchValue?.length === 0){
      setDropdownResult([]);
    }
    
},[debouncedSearchValue])


  function handleChange(e) {
    setSearchText(e.target.value);
  }
  console.log('print', searchText , debouncedSearchValue);

  return (
    <div className={`relative ${type === 2 ? 'w-full' : 'w-[30%]'} flex flex-col items-center justify-center`}>
    <form className='w-full' onSubmit={(e)=> { e.preventDefault(); if(searchText)window.open(`https://personalise.learntube.ai?skill_slug=${searchText}&utm_source=${utmSource}&utm_medium=search-result`) } }>
      <div className={`${!count ? 'bg-white' : 'bg-[#D4F4FF]'} w-full rounded-lg relative  flex items-center justify-center `}>
        
            <input
              placeholder="Search or add a new course "
              className={`focus:border-opacity-[100%] w-full rounded-lg border-[0.5px] border-[#FFFFFF] border-opacity-[60%] ${!count ? 'bg-white' : 'bg-[#D4F4FF]'} px-2 py-2 pl-10 text-sm`}
              onChange={handleChange}
              onFocus={(e)=> { setIsOpenModal(true)}}
              onBlur={(e)=> setTimeout(()=>{setIsOpenModal(false)},1000)}
              ref={inputRef}
            ></input>
            <FontAwesomeIcon
              icon={faSearch}
              size={"lg"}
              className="text-[#989898] absolute left-4 opacity-[40%] focus:opacity-[100%]"
            />
            { <FontAwesomeIcon
            icon={faArrowRight}
            size={"sm"}
            className="bg-[#1F90CF] p-1 rounded-full text-white absolute right-2  cursor-pointer"
            onClick={(e)=> {if(searchText)window.open(`https://personalise.learntube.ai?skill_slug=${searchText}&utm_source=${utmSource}&utm_medium=search-result`); inputRef.current.value = "" ; setSearchText(""); }}
            />}
      </div>
    </form>
    {dropdownResult?.length > 0 && isOpenModal && <div className='absolute top-10 z-[999] h-[196px] w-full overflow-scroll mt-2 bg-[#D4F4FF] search-box' >
    {
       dropdownResult?.map((item)=><div className='hover:bg-[#ABE9FF] py-2 px-4 font-montserrat text-[14px] font-semibold' onClick={(e)=> window.open(`https://personalise.learntube.ai?skill_slug=${item}&utm_source=${utmSource}&utm_medium=search-result`)}>
        {item}
       </div>)
    }
    </div>
    
}
  </div>
  )
  
}

export default SearchBar
